import { FC } from "react"
import { Link } from "react-router-dom"
import Button from "../components/Button"

const NotFound: FC = () => {
  return (
    <div className="container">
      <h1>Page not found</h1>

      <Link to="/">
        <Button>Homepage</Button>
      </Link>
    </div>
  )
}

export default NotFound
